import { Routes } from '@angular/router';
import { WidgetSetupComponent } from './setup/form/widget_setup.component';
import { WizardComponent } from '../containers/main/wizard/wizard.component';
import { WidgetPreviewComponent } from './setup/preview/widget_preview.component';
import { SetupStepNavComponent } from '../shared/navigation/setup_step/setup_step_nav.component';

export const widgetRoutes: Routes = [

    {path: '', component: WidgetPreviewComponent, outlet: 'side'},
    {path: '', component: WizardComponent, outlet: 'main', children: [
      { path: '',
        component: WidgetSetupComponent,
        outlet: 'stepContent'
      },
      { path: '',
        component: SetupStepNavComponent,
        outlet: 'stepNavigation'
      }
    ]}
];
